import apiClient from './axiosConfig'; // Import apiClient
import { API_ENDPOINTS } from '../constants';

const fetchBlogs = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.paginate) query.append('paginate', params.paginate);
  if (params.limit) query.append('limit', params.limit);
  if (params.per_page) query.append('per_page', params.per_page);
  if (params.page) query.append('page', params.page);
  if (params.categorySlug) query.append('category_slug', params.categorySlug); // Add categorySlug param

  try {
    const response = await apiClient.get(`${API_ENDPOINTS.BLOGS}?${query.toString()}`); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching blogs:', error);
    throw error;
  }
};

const fetchBlogDetail = async (slug) => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.BLOG_DETAIL(slug)); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching blog detail:', error);
    throw error;
  }
};

const fetchBlogCategories = async (slug) => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.BLOG_CATEGORIES(slug)); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching blog categories:', error);
    throw error;
  }
};

const fetchBlogCategoryBySlug = async (slug) => { // New function to fetch single category by slug
  try {
    const response = await apiClient.get(API_ENDPOINTS.BLOG_CATEGORY_DETAIL(slug));
    return response.data;
  } catch (error) {
    console.error(`Error fetching blog category by slug ${slug}:`, error);
    throw error;
  }
};

const fetchBlogsByCategory = async (categorySlug, params = {}) => {
  const query = new URLSearchParams();
  if (params.paginate) query.append('paginate', params.paginate);
  if (params.limit) query.append('limit', params.limit);
  if (params.per_page) query.append('per_page', params.per_page);
  if (params.page) query.append('page', params.page);

  try {
    const response = await apiClient.get(`${API_ENDPOINTS.BLOGS_BY_CATEGORY(categorySlug)}?${query.toString()}`); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching blogs by category:', error);
    throw error;
  }
};

const fetchBlogCategoriesWithBlogs = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.BLOG_CATEGORIES_WITH_BLOGS); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching blog categories with blogs:', error);
    throw error;
  }
};

export { fetchBlogs, fetchBlogDetail, fetchBlogCategories, fetchBlogCategoryBySlug, fetchBlogsByCategory, fetchBlogCategoriesWithBlogs };